
// Helper function to get auth token
function getAuthToken() {
  return localStorage.getItem("token") || localStorage.getItem("authToken")
}

// Helper function for API calls
async function fetchApi(endpoint, options = {}) {
  try {
    const token = getAuthToken()
    const headers = {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    }

    // Add Authorization header if token exists
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
      ...options,
      headers,
    })

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`)
    }

    const data = await response.json()
    return {
      success: true,
      data,
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: error.message || "Unknown error occurred",
    }
  }
}

// Service Categories
export const getServiceCategories = () => fetchApi("/services/categories")
export const getAllCatagoryServices = (id) => fetchApi(`/services/sub-categories/by-main/${id}`)
export const getServiceRequest = (id) => fetchApi(`/service-requests/${id}`)

// Customer Dashboard
export const getCustomerDashboard = (recentLimit = 5) => 
  fetchApi(`/services/customer/dashboard?recentLimit=${recentLimit}`)